export const styles = {
  hightlight: {
    fontWeight: 'bold',
  },
};
